import { render } from "./CrudDemo.vue?vue&type=template&id=0fd66d69&scoped=true"
import script from "./CrudDemo.vue?vue&type=script&lang=js"
export * from "./CrudDemo.vue?vue&type=script&lang=js"

import "./CrudDemo.vue?vue&type=style&index=0&id=0fd66d69&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/poseidon-vue-1.0.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd66d69"]])

export default __exports__